<template>
  <view  class="ts-icon-container" wx:class="{{externClass}}">
    <view wx:if="{{!useCatch}}" wx:class="{{svgClass}}" wx:style="{{svgStyle}}" bindtap="click" />
    <view wx:else wx:class="{{svgClass}}" wx:style="{{svgStyle}}" catchtap="click" />
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import { iconMap } from './icon-map'
  import { svgToDataUri, updateSvgFill, px2vw } from './utils'
  import { debounce } from '@didi/spring-base'

  createComponent({
    props: {
      externClass: {
        type: String,
        value: ''
      },
      externStyle: {
        type: Object,
        value: () => {}
      },
      h: {
        type: Number,
        optionalTypes: [String],
        value: 0
      },
      w: {
        type: Number,
        optionalTypes: [String],
        value: 0
      },
      size: {
        type: Number,
        optionalTypes: [String],
        value: 0
      },
      name: {
        type: String,
        value: ''
      },
      color: {
        type: String,
        value: ''
      },
      useCatch: {
        type: Boolean,
        value: false
      }
    },
    created() {
      this.handleClick = debounce(
        () => {
          this.triggerEvent('click')
        },
        300,
        { leading: true, trailing: false }
      )
    },
    data() {
      return {
        handleClick: null
      }
    },
    computed: {
      // svgPath() {
      //   return svgToDataUri(updateSvgFill(iconMap[this.name], this.color))
      // },
      // 考虑到不同项目的兼容性，统一转vw，vh，注意设计稿的viewport
      svgClass() {
        return `ts-icon spring-${this.name}`
      },
      svgStyle() {
        return this.size
          ? {
              color: this.color,
              height: px2vw(this.size),
              width: px2vw(this.size),
              ...this.externStyle
            }
          : {
              color: this.color,
              height: px2vw(this.h),
              width: px2vw(this.w),
              ...this.externStyle
            }
      }
    },
    methods: {
      click(){
        this.handleClick()
      },
    }
  })
</script>

<style scoped lang="stylus" src='./index.styl'></style>


<style scoped lang="stylus">
  .ts-icon-container
    display inline-block
  .ts-icon
    position relative
    display block
    mask-size 100% 100%
    mask-repeat no-repeat
    background-color currentColor
    overflow hidden
    &::before
      content ''
      position absolute
      top -10px
      bottom -10px
      left -10px
      right -10px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {}
  }
</script>